/** Licenses */

'use strict'

$(document).ready(function () {
  // Navigation Scrollspy
  let sections = {};
  $('section').each((_, e) => {
    sections[e.id] = e.offsetTop + 420;
  });

  $(window).scroll(function () {
    for (let key in sections) {
      if ($(window).scrollTop() >= sections[key]) {
        $('.js-nav__items').removeClass('active');
        $(`.js-nav__items[href="#${key}"]`).addClass('active');
      }
    }
  });
});